import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';

interface CardProps {
  children: React.ReactNode;
  padding?: string;
  maxWidth?: string;
  className?: string;
}

const StyledCard = styled.div.withConfig({
  shouldForwardProp: (prop) => !['theme', 'padding', 'maxWidth'].includes(prop),
})<{ theme: any; padding: string; maxWidth: string }>`
  background-color: ${props => props.theme.isDark ? `${props.theme.colors.surface}e8` : `${props.theme.colors.surface}f0`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: ${props => props.padding};
  box-shadow: ${props => props.theme.isDark ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)'};
  width: 100%;
  margin: 0 auto;
  transition: all 0.3s ease;
  position: relative;
  z-index: 5;

  &:hover {
    box-shadow: ${props => props.theme.isDark ? '0 8px 30px rgba(0, 0, 0, 0.4)' : '0 8px 25px rgba(0, 0, 0, 0.15)'};
    background-color: ${props => props.theme.isDark ? `${props.theme.colors.surface}f0` : `${props.theme.colors.surface}f5`};
  }
`;

const Card: React.FC<CardProps> = ({
  children,
  padding = '2rem',
  maxWidth = '600px',
  className,
}) => {
  const { theme } = useTheme();

  return (
    <StyledCard className={className} theme={theme} padding={padding} maxWidth={maxWidth}>
      {children}
    </StyledCard>
  );
};

export default Card;
